module.exports = __webpack_public_path__ + "static/media/successHand.ac6955d0.svg";